// extracted by mini-css-extract-plugin
module.exports = {"facebook-registration":"x24aJ"};